import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { State } from '../model/eform-type';
import { listMenus } from '../config/list-menu';
import { CdkDragStart, CdkDragEnd } from '@angular/cdk/drag-drop';
import { EFormHelper } from '../helper/script/helper';
import { ErorsMessage } from '../helper/script/error-message';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
@Component({
   selector: 'app-form-control',
   templateUrl: './form-control.component.html',
   styleUrls: ['./form-control.component.scss']
})

export class FormControlComponent implements OnInit {
   @Input() state: State;
   @Input() eForm: FormGroup;
   @Input() eventsState : Observable<void>;
   eventsStateChild: Subject<void> = new Subject<void>();
   @Output() createController = new EventEmitter<string>();
   @Output() createControllerTable = new EventEmitter<string>();
   @Output() sendFocus = new EventEmitter<boolean>();
   clickEvents: EventEmitter<string> = new EventEmitter<string>();
   @Input() clickEventsListener: EventEmitter<string>;
   helper = new EFormHelper();
   errMsg = new ErorsMessage(this.translate);
   menus = listMenus;
   defaultLabel: string;

   newSectionState: any

   constructor(public translate: TranslateService) {
   }

   ngOnInit(): void {
      this.defaultLabel = (this.state.name === 'f-table') ? 'Table Name' : 'Label Name';
      this.newSectionState = false;


      this.clickEventsListener.subscribe((res: string) => {
         if(this.state.name === 'f-control-new-section'){
            this.newSectionState = true
            this.state.name = 'f-control';
         }else{
            this.newSectionState = false
         }

         if (res === 'f-address' || res  === 'f-name') {
            this.clickEvents.emit('change');
         }
      });
      this.eventsState.subscribe(() => {
         this.eventsStateChild.next();
      })
   }

   sendControllerToCreate(control: string) {
      this.createController.emit(control);
   }

   sendControllerToCreateTable(control: string) {
      this.createControllerTable.emit(control);
   }

   sendFocusToCreate(focus: boolean) {
      this.sendFocus.emit(focus);
   }

   dragStarted(event: CdkDragStart) {
      const menuGroupType = event.source.data;
      let arrMenuType: Array<any>;
      switch (menuGroupType.arr) {
         case 1: arrMenuType = this.menus.type_1;
            break;
         case 2: arrMenuType = this.menus.type_2;
            break;
         case 3: arrMenuType = this.menus.type_3;
            break;
         case 5: arrMenuType = this.menus.type_5;
            break;
         case 6: arrMenuType = this.menus.type_6;
            break;
         default: this.menus.type_4.push({ arr: 4, name: 'Section', id: 'f-section', icon: 'zoom_out_map' }); break;
      }

      if (menuGroupType.arr !== 4 ) {
         const menuIndex = arrMenuType.findIndex((v: { id: number; }) => v.id === menuGroupType.id);
         const menuControl = arrMenuType.find((v: { id: number; }) => v.id === menuGroupType.id);
         arrMenuType.splice(menuIndex, 0, menuControl);
      }
   }

   dragEnded(event: CdkDragEnd) {
      const menuGroupType = event.source.data;
      let arrMenuType: Array<any>;
      switch (menuGroupType.arr) {
         case 1: arrMenuType = this.menus.type_1;
            break;
         case 2: arrMenuType = this.menus.type_2;
            break;
         case 3: arrMenuType = this.menus.type_3;
            break;
         case 5: arrMenuType = this.menus.type_5;
            break;
         case 6: arrMenuType = this.menus.type_6;
            break;
         default: this.menus.type_4.pop(); break;
      }

      if (menuGroupType.arr !== 4 ) {
         arrMenuType.splice(arrMenuType.findIndex((v: { id: number; }) => v.id === menuGroupType.id), 1);
      }
   }

   get currentFieldGroup(): FormGroup {
      return this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex);
   }

   get currentTableFieldGroup(): FormGroup {
      return this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex);
   }

}
